<template>
  <t-modal
    :name="`sunpod-accept`"
    :variant="`confirmation`"
    :hideCloseButton="true"
    :disableBodyScroll="true"
    :escToClose="!isLoading"
    :clickToClose="!isLoading"
    @closed="onClose"
  >
    <section class="overflow-auto h-96">
      <section class="px-4 pt-4 text-2xl font-extrabold text-center">
        {{
          $t(
            'components.pods.sunpods.details.steps.vehicles.assignVehicle.headline'
          )
        }}
      </section>

      <div class="px-5 pt-5">
        <ValidationObserver v-slot="{ handleSubmit }" ref="observer">
          <form
            @submit.prevent="handleSubmit(onConfirm())"
            enctype="multipart/form-data"
          >
            <div class="relative mb-1 ">
              <AppInput
                v-model="globalSearch"
                type="text"
                :placeholder="
                  $t(
                    'components.pods.sunpods.details.steps.vehicles.assignVehicle.placeHolder'
                  )
                "
                @focus="focusUpdate"
                @blur="blurUpdate"
                class="px-2 py-1 search-area"
                :isSearch="true"
              />

              <div
                class="absolute right-0 left-0 top-auto z-10 py-1 bg-white rounded rounded-t-none border border-t-0 "
              >
                <template v-if="isLoadingVehicles && isShow">
                  <p class="mx-1">Loading...</p>
                </template>

                <template
                  v-if="
                    !isLoadingVehicles &&
                      globalSearchResults.length === 0 &&
                      isShow
                  "
                >
                  <div
                    class="flex justify-between items-center py-2 px-2 text-sm font-medium"
                  >
                    <div>
                      {{
                        $t(
                          'components.pods.sunpods.details.steps.vehicles.assignVehicle.message'
                        )
                      }}
                    </div>

                    <i class="block text-red-500 fas fa-exclamation-circle" />
                  </div>
                </template>
                <!-- /not-found -->

                <!-- results -->
                <div
                  v-if="
                    !isLoadingVehicles &&
                      globalSearchResults.length > 0 &&
                      isShow
                  "
                  class="list-container"
                >
                  <div
                    class="flex justify-between items-center py-2 px-2 text-sm cursor-pointer hover:bg-gray-100 "
                    v-for="result in globalSearchResults"
                    :key="result.id"
                    @click="onSet(result)"
                  >
                    <div class="w-6/12">
                      <span class="text-gray-700">{{ result.name }}</span>
                      <br />
                      <span class="text-xs text-gray-500">{{
                        result.qr_code
                      }}</span>
                    </div>

                    <div class="w-4/12">
                      <span class="text-gray-400 text-sm">{{
                        result.organization_vehicle_model.title || '--'
                      }}</span>
                    </div>

                    <div class="w-2/12 flex items-center justify-end">
                      <HeartbeatStatus
                        :status="result.lock.is_operational"
                        :text-class="`ml-2 text-xs`"
                        :is-available="result.is_available"
                      />
                    </div>
                  </div>
                </div>
                <!-- /results -->
              </div>
            </div>

            <button type="submit" ref="submitButtonRef" class="hidden">
              {{ $t('components.stepNavigation.confirm') }}
            </button>
          </form>
        </ValidationObserver>
      </div>

      <div class="absolute bottom-0 w-full">
        <section
          class="flex items-center justify-end px-4 py-4 mt-6 space-x-5 bg-gray-50 "
        >
          <AppButton
            :disabled="isLoading"
            :variant="`secondary`"
            :class="`w-1/2`"
            @click="onClose"
          >
            {{ $t('components.stepNavigation.cancel') }}
          </AppButton>

          <AppButton
            :variant="`primary`"
            :class="`w-1/2`"
            :isLoading="isLoading"
            :disabled="isLoading"
            @click="$refs.submitButtonRef.click()"
          >
            {{ $t('components.stepNavigation.assign') }}
          </AppButton>
        </section>
      </div>
    </section>
  </t-modal>
</template>

<script>
import { xMan } from '@/utils'
import { SunpodsConfig } from '@/config/SunpodsConfig'
import Qs from 'qs'
import HeartbeatStatus from '@/components/badge/HeartbeatStatus.vue'
export default {
  props: {
    sunpodId: {
      type: String,
      required: true,
    },
  },
  components: { HeartbeatStatus },
  mounted() {
    this.$modal.show('sunpod-accept')
  },
  data() {
    return {
      isLoading: false,
      isLoadingVehicles: false,
      globalSearch: '',
      globalSearchResults: [],
      isShow: false,
      form: {
        vehicle: {
          qr_code: null,
          id: null,
        },
      },
    }
  },
  watch: {
    // updated is string
    globalSearch(updated) {
      if (updated == '') {
        this.globalSearch = ' '
      } else if (updated.length > 0) {
        this.onFetchVehicles(updated)
      } else {
        this.globalSearchResults = []
      }
    },
  },
  methods: {
    async onFetchVehicles(query) {
      this.isLoadingVehicles = true
      console.log('que', query)
      await this.$http
        .get(SunpodsConfig.api.assignableVehicles(this.sunpodId), {
          params: {
            search: query,
          },
          paramsSerializer: function(params) {
            return Qs.stringify(params, { arrayFormat: 'repeat' })
          },
        })
        .then(({ data }) => {
          this.globalSearchResults = data?.data
        })
        .catch((err) => {
          console.log('onFetchUsersErr', err, err.response)
        })
        .finally(() => (this.isLoadingVehicles = false))

      return { results: this.vehicles }
    },
    onSearch() {
      this.isShow = !this.isShow
      if (this.isShow) {
        this.globalSearch = this.form.vehicle.qr_code ?? ' '
      }
    },
    onSet(vehicle) {
      this.isShow = false
      this.globalSearch = vehicle.qr_code
      this.form.vehicle.qr_code = vehicle.qr_code
      this.form.vehicle.id = vehicle.id
    },
    onClose(shouldUpdate) {
      this.$emit('close', shouldUpdate)
    },
    focusUpdate(e) {
      console.log('update-focus', e.target.value)
      this.isShow = true
      this.onFetchVehicles(e.target.value || '')
    },
    onConfirm() {
      const self = this
      const form = this.form
      this.isShow = false
      this.isLoading = true

      const formDataProxy = {
        vehicle_id: form.vehicle.id,
      }

      const formData = new xMan(formDataProxy).toFormData()

      this.$http
        .post(SunpodsConfig.api.addVehicle(this.sunpodId), formData)
        .then((res) => {
          console.log(res)
          this.$emit('refresh')
          self.$notify(
            {
              group: 'bottomRight',
              type: 'success',
              title: `Success`,
              text: `Vehicle has been assigned successfully`,
            },
            5000
          )
          self.$store.dispatch('fsTable/fetchData')
        })
        .catch((err) => {
          console.log('onConfirm', err, err.response.data.message)
          self.$notify(
            {
              group: 'bottomRight',
              type: 'error',
              title: `Error`,
              text: err.response.data.message ?? `Failed to assign vehicles`,
            },
            5000
          )
        })
        .finally(() => {
          self.isLoading = false
          self.onClose(true)
        })
    },
  },
}
</script>
<style scoped lang="scss">
.search-area {
  width: 100%;
  height: 52px;
  border-radius: 7px;
  border: solid 1px #ffffff;
  background-color: #f2f2f2;
}
.list-container {
  max-height: 10rem;
  overflow-y: auto;
}
</style>
